// ProductTitle.js

import React, { Component } from 'react';
import { Button, Form, Table, Container, Row, Col, ButtonToolbar, Overlay, Popover } from 'react-bootstrap';
import Config from '../Config';
import ScrollArea from 'react-scrollbar';
import Modal from 'react-awesome-modal';

class RowItem extends Component {
    static defaultProps = {
        key: null,
        item: null,
        enable: false,
        onPress: () => { },
        onChange: () => { },
    }
    constructor(props) {
        super(props);
        this.state = {
            item: this.props.item
        };
    }

    componentWillReceiveProps(nextProps) {
        // console.log("componentWillReceiveProps: " + JSON.stringify(nextProps));
        this.setState({
            item: nextProps.item
        });
    }

    handleRowClick = () => {
        this.props.onPress(this.props.item);
        event.preventDefault();
    }

    handleChangeTITLE = (event) => {
        var item = this.state.item;
        item.TITLE = event.target.value;
        this.props.onChange(item);
        event.preventDefault();
    }

    handleChangeNOTE = (event) => {
        var item = this.state.item;
        item.CONTENT = event.target.value;
        this.props.onChange(item);
        event.preventDefault();
    }

    handleChangeRTSEC = (event) => {
        var item = this.state.item;
        item.PLAYTIME = event.target.value;
        this.props.onChange(item);
        event.preventDefault();
    }

    handleSubmit = () => {

    }

    render() {
        return (
            <tr onClick={this.handleRowClick}>
                <td>{this.props.item.ID}</td>
                <td>{this.props.item.CLIP}</td>
                <td>
                    <Form.Control type="title" placeholder="입력하세요." value={this.state.item.TITLE} onChange={this.handleChangeTITLE.bind(this)} />
                </td>
                <td width="40%">
                    <Form.Control as="textarea" rows="2"  placeholder="입력하세요." value={this.state.item.CONTENT} onChange={this.handleChangeNOTE.bind(this)} />
                </td>
                <td width="80">
                    <Form.Control type="title" placeholder="입력하세요." value={this.state.item.PLAYTIME} onChange={this.handleChangeRTSEC.bind(this)} />
                </td>
                <td>{this.props.item.THUMBNAIL}</td>
            </tr>
        );
    }
};

export default class ProductTitle extends Component {
    static defaultProps = {
        item: null,
        images: null,
        enable: false,
        onPress: () => { },
    }
    constructor(props) {
        super(props);
        this.timer = null;
        this.locals = Config.ProductLangs;
        this.emptyItem = {
            ID: 0,
            PCODE: "0000",
            IDX: "",
            LANG: "",
            TITLE: "",
            PLAYTIME: 0,
            THUMBNAIL: "",
            CONTENT: ""
        }
        this.state = {
            timages: [],
            rowlist: [],
            answervisible: false,
            enable: true,
            item: this.props.item,
            images: this.props.images,
            language: this.locals[0],
            details: [],
            prv_lang : this.locals[0]
        };
    }

    componentWillReceiveProps(nextProps) {
        // console.log("componentWillReceiveProps: " + JSON.stringify(nextProps));
        this.setState({ item: nextProps.item, images: nextProps.images });
        this.refreshGetInfo();
    }

    refreshGetInfo() {
        if (this.timer)
            clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.handleGetInfo(null);
        }, 500);
    }

    handleDetail() {
        this.setState({ answervisible: true });
    }

    handleClose() {
        this.setState({ answervisible: false });
    }

    handleGetInfo(event) {
        Config.fetchData('producttitle', {
            PCODE: this.state.item.PCODE
        }, (result, count) => {
            console.log('producttitle=', result);
            this.setState({ details: result }, () => {
                this.handleChangeDetail(this.state.language);
            })
        }, true);
    }

    handleChangeDetail(lang) {
        const result = this.state.details.filter((data) => { return data.LANG == lang });
        if (result.length > 0)
        {
            this.setState({ rowlist: result });
            this.setState({ prv_lang: lang });
        }
        else
        {
            var flt_result = this.state.details.filter((data) => { return data.LANG == this.state.prv_lang });
            var prv_result = [];
            flt_result.forEach((item) => {
                var newitem = {...item};
                newitem.LANG = lang;
                prv_result.push( newitem );
            });
            this.setState({ rowlist: prv_result });
        }
    }

    handleChangeLanguage(event) {
        this.setState({ language: event.target.value }, () => {
            this.handleChangeDetail(this.state.language);
        });
    }

    handleChangeTITLE(event) {
        var item = this.state.detail;
        item.TITLE = event.target.value;
        this.setState({ detail: item });
    }

    handleChangeTIMAGE(event) {
        var item = this.state.detail;
        item.TIMAGE = event.target.value;
        this.setState({ detail: item });
    }

    handleChangeNOTE(event) {
        var item = this.state.detail;
        item.CONTENT = event.target.value;
        this.setState({ detail: item });
    }

    handleChangePRODUCTION(event) {
        var item = this.state.detail;
        item.PRODUCTION = event.target.value;
        this.setState({ detail: item });
    }

    handleChangeARTIST(event) {
        var item = this.state.detail;
        item.ARTIST = event.target.value;
        this.setState({ detail: item });
    }


    handleSubmit(event) {
        var result = confirm("저장 하시겠습니까?");
        if (result) {
            Config.fetchData('insproducttitle', {
                LIST: this.state.rowlist
            }, (result, count) => {
                console.log('insproducttitle=', count);
                this.refreshGetInfo();
            }, true);
        }
        event.preventDefault();
    }

    handleRemove(event) {
        var result = confirm("삭제 하시겠습니까?");
        if (result) {
            Config.fetchData('delproducttitle', {
                PCODE: this.state.item.PCODE,
                LANG: this.state.language
            }, (result, count) => {
                console.log('delproducttitle=', count);
                this.refreshGetInfo();
            }, true);
        }
        event.preventDefault();
    }

    handleGetFromS3(event) {
        Config.fetchData('getproductfiles', {
            PCODE: this.state.item.PCODE,
            FOLDER: '/timages'
        }, (result, count) => {
            console.log('getproducttimages=', result);
            var imagelist = [];
            for (var i = 0; i < result.length; ++i) {
                var item = { ...this.emptyItem };
                item.ID = i;
                item.PCODE = this.state.item.PCODE;
                item.CLIP = result[i].name.substr(0, result[i].name.indexOf('.'));
                item.LANG = this.state.language;
                item.TITLE = result[i].name.substr(0, result[i].name.lastIndexOf('.'));
                item.THUMBNAIL = result[i].name;
                item.CONTENT = '';
                imagelist.push(item);
            }
            this.setState({ rowlist: imagelist })
        }, true);
        event.preventDefault();
    }


    handleRowClick = () => {
        event.preventDefault();
    }

    handleRowChange = (item) => {
        var row = this.state.rowlist;
        // row[item.ID] = item;
        // console.log( JSON.stringify( row ) );
        this.setState({ rowlist: row });
        event.preventDefault();
    }

    render() {
        let scrollbarStyles = { borderRadius: 5 };
        return (
            <div className="box" >
                <div className="row" style={{ margin: 10 }}>
                    <div className="col-md-12">
                        <Button variant="primary" onClick={this.handleSubmit.bind(this)}>저장</Button>
                        <Button variant="primary" onClick={this.handleGetFromS3.bind(this)}>S3에서 가져오기</Button>
                        <Button variant="primary" onClick={this.handleRemove.bind(this)}>삭제</Button>
                    </div>
                </div>
                <div className="row" style={{ margin: 10 }}>
                    <div className="col-md-6">
                        <Form.Group as={Col} controlId="exampleForm.ControlInput1">
                            <Form.Label>상품코드</Form.Label>
                            <Form.Control type="title" placeholder="코드를 입력하세요." value={this.state.item.PCODE} />
                        </Form.Group>
                    </div>
                    <div className="col-md-6">
                        <Form.Group as={Col} controlId="exampleForm.ControlSelect1">
                            <Form.Label>언어선택</Form.Label>
                            <Form.Control as="select" value={this.state.language} onChange={this.handleChangeLanguage.bind(this)}>
                                {Config.ProductLangs.map((item, index) =>
                                    <option>{item}</option>
                                )}
                            </Form.Control>
                        </Form.Group>
                    </div>
                </div>
                <div className="row" style={{ margin: 10 }}>
                    <hr />
                </div>
                <div className="row" style={{ margin: 10 }}>
                    <ScrollArea style={{ width: '100%', height: 500 }}
                        className="area"
                        contentClassName="content"
                        verticalScrollbarStyle={scrollbarStyles}
                        verticalContainerStyle={scrollbarStyles}
                        horizontalScrollbarStyle={scrollbarStyles}
                        horizontalContainerStyle={scrollbarStyles}
                        smoothScrolling={true}
                        minScrollSize={5}
                        onScroll={this.handleScroll}
                    >
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <td>#</td>
                                    <td>CLIP</td>
                                    <td>타이틀</td>
                                    <td width="40%">CONTENT</td>
                                    <td width="80">재생(초)</td>
                                    <td>썸네일</td>
                                </tr>
                            </thead>
                            <tbody>

                                {this.state.rowlist.map((item, index) =>
                                    <RowItem key={index} item={item} onPress={this.handleRowClick.bind(this)} onChange={this.handleRowChange.bind(this)} />
                                )}

                            </tbody>
                        </Table>
                    </ScrollArea>
                </div>


            </div>

        );
    }
};





// WEBPACK FOOTER //
// src/components/ProductTitle.js